import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MomentPipe } from "./pipes/moment.pipe";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";
import { RippleModule } from "primeng/ripple";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";
import { InputGroupModule } from "primeng/inputgroup";
import { TabViewModule } from "primeng/tabview";
import { ToastModule } from "primeng/toast";
import { TableModule } from "primeng/table";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { DropdownModule } from "primeng/dropdown";
import { InputTextareaModule } from "primeng/inputtextarea";
import { TooltipModule } from "primeng/tooltip";
import { RadioButtonModule } from "primeng/radiobutton";
import { CalendarModule } from "primeng/calendar";

const modules = [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    PasswordModule,
    RippleModule,
    InputGroupAddonModule,
    InputGroupModule,
    TabViewModule,
    ToastModule,
    ReactiveFormsModule,
    TableModule,
    DropdownModule,
    InputTextareaModule,
    TooltipModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    CalendarModule
];

const directives = [];

const pipes = [
    MomentPipe
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ...modules,

    ],
    declarations: [
        ...pipes,
        ...directives],
    exports: [
        CommonModule,
        ...modules,
        ...pipes,
        ...directives
    ],
})
export class ThirdPartySharedM {
}
